module.exports = __webpack_public_path__ + "static/media/ico-colored-video-camera.127311ee.svg";